import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  ellipsis: {
    display: "block",
    textOverflow: "ellipsis",
    overflowX: "hidden"
  }
});
